import React from "react";
import useFetch from "../hooks/useFetch";
import { v4 as uuidv4 } from "uuid";
import { Autoplay, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/effect-fade";

import AnimatedContent from "./animation/AnimatedContent";

export default function PartnersSection() {
  const partnersFetch = useFetch(
    `${window.$host}/api/partner?populate[Partners][populate]=*`
  );

  if (partnersFetch.loading) return;
  if (partnersFetch.error) return;

  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 1099px)").matches;

  const MaybeAnimate = ({ enabled, children, ...props }) =>
    enabled ? <AnimatedContent {...props}>{children}</AnimatedContent> : children;

  let arrLenght = Math.ceil(partnersFetch.data.data.Partners.length / 4);

  return (
    <section className="partners" id="partners">
      <div className="container">
        <div className="h-100 content-box">
          <div className="partners__box">
            <MaybeAnimate enabled={!isMobile} delay={0.10}>
              <h2 className="title-3 partners__title">
                {partnersFetch.data.data.Title}{" "}
                <span className="text-blue">
                  {partnersFetch.data.data.TitleBlue}
                </span>
              </h2>
            </MaybeAnimate>
            <ul className="partners__list">
              {[0, 1, 2, 3].map((idx) => {
                const rowDelay = 0.30 + Math.floor(idx / 2) * 0.20;

                return (
                  <li className="partners__item" key={uuidv4()}>
                    <MaybeAnimate enabled={!isMobile} delay={rowDelay}>
                      <Swiper
                        className="swiper partners__swiper"
                        modules={[Autoplay, EffectFade]}
                        loop={true}
                        initialSlide={idx * arrLenght}
                        speed={900}
                        slidesPerView={1}
                        spaceBetween={0}
                        allowTouchMove={false}
                        autoplay={{
                          delay: 3000,
                          disableOnInteraction: false,
                        }}
                        effect={"fade"}
                        fadeEffect={{
                          crossFade: true,
                        }}
                        onInit={(swiper) => {
                          swiper.autoplay.pause();

                          let timer = 500;

                          if (idx % 2 === 0) {
                            if (idx !== 0) {
                              timer = (timer / 1.5) * idx;
                            }
                          } else {
                            timer = (timer / 2) * idx;
                          }

                          setTimeout(() => {
                            if (swiper.autoplay) {
                              swiper.autoplay.resume();
                            }
                          }, timer);
                        }}
                      >
                        {partnersFetch.data.data.Partners.map((item) => (
                          <SwiperSlide className="swiper-slide" key={item.id}>
                            <div className="partners__slide">
                              <img
                                className="partners__logo"
                                src={window.$host + item.LogoMono.url}
                                alt={item.LogoMono.alternativetext}
                              />
                              <img
                                className="partners__logo-hover"
                                src={window.$host + item.Logo.url}
                                alt={item.Logo.alternativetext}
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </MaybeAnimate>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
